import React, { useState } from 'react'
import './Header.css'
import MenuIcon from '@mui/icons-material/Menu'
import Icon from './images/YouTube-Logo.wine.svg'
import SearchIcon from '@mui/icons-material/Search'
import { VideoCall, Apps, Notifications } from '@mui/icons-material'
import { Avatar } from '@mui/material'
import { Link, useNavigate } from 'react-router-dom'

function Header() {
  const [inputSearch, setInputSearch] = useState('')
  const navigate = useNavigate()

  const handleSearch = () => {
    if (inputSearch.trim() !== '') {
      navigate(`/search/${inputSearch}`)
    }
  }

  return (
    <div className="header">
      <div className="header__left">
        <MenuIcon />
        <Link to={`/`}>
          <img className="header__logo" src={Icon} alt="YouTube icon" />
        </Link>
      </div>
      <div className="header__input">
        <input
          onChange={(e) => setInputSearch(e.target.value)}
          value={inputSearch}
          type="text"
          placeholder="Search"
        />
        <SearchIcon className="header__inputButton" onClick={handleSearch} />
      </div>
      <div className="header__icons">
        <VideoCall className="header__icon" />
        <Apps className="header__icon" />
        <Notifications className="header__icon" />
        <Avatar
          alt="Akinkunmi Akinnitire"
          src="https://avatars.githubusercontent.com/u/52933537?v=4"
        />
      </div>
    </div>
  )
}

export default Header
